import React from "react";
import Title from "../Title/Title";
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import ColorModeToggle from '../ColorModeToggle/ColorModeToggle';
import { ONBOARDING_BRAND } from "./onboardingBrand";

export const OnboardingLanguageSwitcher: React.FC = () => (
  <div className="flex items-center justify-center gap-2 mt-2">
    <ColorModeToggle />
    <LanguageSwitcher />
  </div>
);

type OnboardingWizardLayoutProps = {
  children: React.ReactNode;
  fade?: boolean;
  loading?: boolean;
  loadingText?: string;
  title?: string;
  subtitle?: string;
  progressTotal?: number;
  progressIndex?: number;
  showProgress?: boolean;
  overlay?: React.ReactNode;
  maxWidthClass?: string;
};

const OnboardingWizardLayout: React.FC<OnboardingWizardLayoutProps> = ({
  children,
  fade = true,
  loading = false,
  loadingText,
  title,
  subtitle,
  progressTotal,
  progressIndex = 0,
  showProgress = false,
  overlay,
  maxWidthClass = "max-w-4xl",
}) => {
  return (
    <div className={ONBOARDING_BRAND.page}>
      <div className="onboarding-shell-orbs" aria-hidden="true">
        <span className="onboarding-shell-orb onboarding-shell-orb-a" />
        <span className="onboarding-shell-orb onboarding-shell-orb-b" />
        <span className="onboarding-shell-orb onboarding-shell-orb-c" />
      </div>

      <div className={`${ONBOARDING_BRAND.content} ${maxWidthClass} py-8 px-4 sm:px-8`}>
        {overlay ? (
          overlay
        ) : (
          <div className={`transition-all duration-500 ease-in-out ${fade ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {showProgress && progressTotal != null && progressTotal > 0 && (
              <div className="flex justify-center mb-8">
                <div className="flex space-x-2">
                  {Array.from({ length: progressTotal }).map((_, index) => (
                    <div
                      key={index}
                      className={`h-2 w-8 rounded-full transition-all duration-300 ${
                        index <= progressIndex
                          ? ONBOARDING_BRAND.progressActive
                          : ONBOARDING_BRAND.progressIdle
                      }`}
                    />
                  ))}
                </div>
              </div>
            )}

            {(title || subtitle) && (
              <div className="text-center mb-8">
                {title && (
                  <Title
                    text={title}
                    clazz="text-3xl font-bold !text-foreground mb-2 !text-center"
                  />
                )}
                {subtitle && (
                  <p className="text-lg text-muted-foreground mb-4">
                    {subtitle}
                  </p>
                )}
                <div className={ONBOARDING_BRAND.underline} />
              </div>
            )}

            {loading && (
              <div className="text-center text-muted-foreground mb-6 font-medium">
                {loadingText}
              </div>
            )}

            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingWizardLayout;
